// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import {
  AppCheck,
  initializeAppCheck,
  ReCaptchaV3Provider,
} from "firebase/app-check";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBo2LYF85lfmpSOVpJ5kEZI7KZceSeWL1k",
  authDomain: "wedding-bca0e.firebaseapp.com",
  projectId: "wedding-bca0e",
  storageBucket: "wedding-bca0e.firebasestorage.app",
  messagingSenderId: "554924887518",
  appId: "1:554924887518:web:cdb04a0708f8acb46fe14f",
  measurementId: "G-BR9T4T8C1P",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const appCheck: AppCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider("6Ld0-oArAAAAADrifYI56gPcoGNczVFfb74yW458"),
  isTokenAutoRefreshEnabled: true,
});

const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);
export const storage = getStorage(app);

export { db, auth };
